/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


(function market365ProductPurchaseDetailsBootstrap() {
  var initialized = false;

  function formatPrice(value) {
    try {
      return new Intl.NumberFormat('lt-LT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      }).format(value);
    } catch (error) {
      return value + ' EUR';
    }
  }

  function formatInteger(value) {
    if (!Number.isFinite(value)) {
      return 'Nenurodyta';
    }

    try {
      return new Intl.NumberFormat('lt-LT', {
        maximumFractionDigits: 0
      }).format(value);
    } catch (error) {
      return String(value);
    }
  }

  function formatRatingValue(value) {
    if (!Number.isFinite(value)) {
      return 'Nenurodyta';
    }

    return value.toFixed(2) + ' / 5';
  }

  function formatRatingStars(value) {
    if (!Number.isFinite(value)) {
      return '☆☆☆☆☆';
    }

    var fullStars = Math.max(0, Math.min(5, Math.round(value)));
    return '★'.repeat(fullStars) + '☆'.repeat(5 - fullStars);
  }

  function updatePriceLabels(expectedPrice) {
    var selectors = [
      '.price-item--regular',
      '.price__regular .money',
      '.product__price .money',
      '[data-product-price]'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        node.textContent = formatPrice(expectedPrice);
      });
    });
  }

  function disableCartButtons() {
    var selectors = [
      'form[action*="/cart/add"] button[type="submit"]',
      'button[name="add"]',
      'button[data-add-to-cart]'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (button) {
        button.disabled = true;
        if (button.textContent) {
          button.textContent = 'Laikinai nepasiekiama';
        }
      });
    });
  }

  function placePurchaseDetails() {
    var details = document.getElementById('market365-product-purchase-details');
    if (!details) return false;

    var infoList = document.querySelector('.product-form__info-list');
    var quantityInput = document.querySelector('input[name="quantity"]');
    var quantityInfoItem = quantityInput ? quantityInput.closest('.product-form__info-item') : null;
    var quantitySelector = quantityInput ? quantityInput.closest('.quantity-selector') : null;
    var fallbackBlock =
      document.querySelector('.product-form__info-item--quantity') ||
      quantityInfoItem ||
      quantitySelector ||
      document.querySelector('form[action*="/cart/add"]');
    var target = infoList || fallbackBlock;

    details.style.display = 'block';

    if (!target || !target.parentNode) {
      return true;
    }

    if (details.previousElementSibling !== target) {
      target.insertAdjacentElement('afterend', details);
    }

    return true;
  }

  function updatePurchaseDetails(payload) {
    var seller = document.querySelector('[data-market365-seller]');
    var buyers = document.querySelector('[data-market365-buyers]');
    var ratingStars = document.querySelector('[data-market365-rating-stars]');
    var ratingValue = document.querySelector('[data-market365-rating-value]');
    var reviews = document.querySelector('[data-market365-reviews]');
    var deliveryEta = document.querySelector('[data-market365-delivery-eta]');

    if (seller && payload && payload.supplierSellerLogin) {
      seller.textContent = payload.supplierSellerLogin;
    }

    if (buyers) {
      buyers.textContent = formatInteger(Number(payload && payload.supplierBuyersLastMonth));
    }

    if (ratingStars) {
      ratingStars.textContent = formatRatingStars(Number(payload && payload.supplierRating));
    }

    if (ratingValue) {
      ratingValue.textContent = formatRatingValue(Number(payload && payload.supplierRating));
    }

    if (reviews) {
      reviews.textContent = formatInteger(Number(payload && payload.supplierReviewsCount));
    }

    if (deliveryEta) {
      deliveryEta.textContent = payload && payload.customerDeliveryText ? payload.customerDeliveryText : 'Nenurodyta';
    }
  }

  function buildLiveCheckUrl(root) {
    var appBaseUrl = root.dataset.appBaseUrl || '';
    if (appBaseUrl.charAt(appBaseUrl.length - 1) === '/') {
      appBaseUrl = appBaseUrl.slice(0, -1);
    }
    return appBaseUrl + '/api/live-check/' + encodeURIComponent(root.dataset.productHandle);
  }

  function run() {
    var root = document.getElementById('allegro-live-check-banner');
    if (!root || initialized) return;
    if (!root.dataset.appBaseUrl || !root.dataset.productHandle) return;

    placePurchaseDetails();
    initialized = true;

    fetch(buildLiveCheckUrl(root))
      .then(function (response) { return response.json(); })
      .then(function (payload) {
        if (payload.error) return;

        placePurchaseDetails();
        updatePurchaseDetails(payload);

        if (!payload.available) {
          root.style.display = 'block';
          root.textContent = payload.message || 'Tiekejas rodo, kad si preke siuo metu neaktyvi arba nebeturima.';
          disableCartButtons();
          return;
        }

        if (!payload.priceMatches || (payload.sync && payload.sync.shopifyPriceUpdated)) {
          root.style.display = 'block';
          root.textContent = payload.message || ('Tiekejo kaina pasikeite. Atnaujinta rekomenduojama kaina: ' + formatPrice(payload.expectedPrice) + '.');
          updatePriceLabels(payload.expectedPrice);
        }
      })
      .catch(function () {
        initialized = false;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function () {
    initialized = false;
    run();
  });
})();
